import { matchPath } from 'react-router-dom';
import { AppMenuListItem } from '@m/alchemy-ui/AppMenuListItem';
import { AppMenuList } from '@m/alchemy-ui/AppMenuList';
import { AppMenuListExpandableItem } from '@m/alchemy-ui/AppMenuListExpandableItem';

import { rewardsReportsLinks } from 'common/constants/menuItems';

import AppNavListItemTertiaryWithoutIcon from './AppNavListItemTertiaryWithoutIcon';
import { NavBarItem } from './types';

interface RewardsReportsProps {
  pathname: string;
  isMobileMenu?: boolean;
}

const RewardsReports = ({ pathname, isMobileMenu }: RewardsReportsProps) => {
  const { unfulfilledRewards, rewardsLog, votes } = rewardsReportsLinks;
  const rewardsReportsMenuLinks: NavBarItem[] = [
    unfulfilledRewards,
    rewardsLog,
    votes,
  ];

  const isRewardsActive = rewardsReportsMenuLinks.some(link =>
    matchPath(pathname, {
      path: link.url,
      exact: true,
    })
  );

  const getMenuListItems = () =>
    rewardsReportsMenuLinks.map(eachItem => (
      <AppMenuListItem key={eachItem.key}>
        <a href={eachItem.url}>{eachItem.label}</a>
      </AppMenuListItem>
    ));

  return isMobileMenu ? (
    <AppMenuListExpandableItem label="Rewards Reports">
      {/* @ts-expect-error */}
      <AppMenuList className="padding-left-medium">
        {getMenuListItems()}
      </AppMenuList>
    </AppMenuListExpandableItem>
  ) : (
    <AppNavListItemTertiaryWithoutIcon
      priority="primary"
      isActive={isRewardsActive}
      label="Rewards Reports"
      overlay={() => (
        // AppMenuList accepts a className prop but it is not present in its interface.
        // @ts-expect-error
        <AppMenuList className="padding-none">{getMenuListItems()}</AppMenuList>
      )}
    />
  );
};

export default RewardsReports;
